"use client";

import { useTimeBasedTheme } from "@/hooks/useTimeBasedTheme";

export function TimeBasedTheme() {
  useTimeBasedTheme();
  return null;
}
